// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HliW6P {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  padding: 0;
}

.uYcL8H {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--spacing-3);
  min-height: 0;
  overflow-y: auto;
  padding: var(--spacing-3);
}

.uB5Fzz {
  display: flex;
  padding: var(--spacing-3);
}

.uB5Fzz > * {
  flex: 1;
}

.tayXPq {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1);
  text-align: center;
}

.llN9xL {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: var(--spacing-2);
  border-radius: 50%;
  background: var(--surface-primary-subtle);
}

.q9MS4j {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.o_4iYD {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.Qrg61T {
  align-items: center;
}

.ktZyoE {
  display: block;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
}

.qgFRh_ {
  margin: 0;
  min-width: 0;
}

.yh9neU[data-testid\$='-content'] {
  width: 400px;
  max-width: calc(100vw - 32px);
  padding: 0;
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-m);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.yh9neU [data-testid\$='-header'] {
  min-height: 0;
}

.yh9neU [data-testid\$='-title'] {
  font-size: 18px;
  font-weight: var(--font-weight-medium);
  line-height: normal;
  color: var(--text-neutral-dark);
}

.yh9neU [data-testid\$='-close-button'] {
  width: auto;
  height: auto;
  margin-left: 0;
  padding: 4px;
  background: transparent;
  flex-shrink: 0;
}

.yh9neU .jtlvHa {
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3);
}

.WP94Ly {
  margin: var(--spacing-1) 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
}

.bfTFBa {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-2);
}

.bfTFBa .iinXwz {
  min-height: 32px;
  padding-top: 0;
  padding-bottom: 0;
  border-width: 1px;
  font-weight: var(--font-weight-medium);
}

.bfTFBa .dkXH_s {
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorAddressList/EmissorAddressList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".panelBody {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  min-height: 0;\n  padding: 0;\n}\n\n.panelContent {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  min-height: 0;\n  overflow-y: auto;\n  padding: var(--spacing-3);\n}\n\n.panelFooter {\n  display: flex;\n  padding: var(--spacing-3);\n}\n\n.panelFooter > * {\n  flex: 1;\n}\n\n.panelState {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1);\n  text-align: center;\n}\n\n.panelStateIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  margin-bottom: var(--spacing-2);\n  border-radius: 50%;\n  background: var(--surface-primary-subtle);\n}\n\n.panelStateTitle {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.panelStateDescription {\n  margin: 0;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.item {\n  align-items: center;\n}\n\n.addressLine {\n  display: block;\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n}\n\n.alert {\n  margin: 0;\n  min-width: 0;\n}\n\n.deleteModal[data-testid$='-content'] {\n  width: 400px;\n  max-width: calc(100vw - 32px);\n  padding: 0;\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-m);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.deleteModal :global([data-testid$='-header']) {\n  min-height: 0;\n}\n\n.deleteModal :global([data-testid$='-title']) {\n  font-size: 18px;\n  font-weight: var(--font-weight-medium);\n  line-height: normal;\n  color: var(--text-neutral-dark);\n}\n\n.deleteModal :global([data-testid$='-close-button']) {\n  width: auto;\n  height: auto;\n  margin-left: 0;\n  padding: 4px;\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.deleteModal .deleteBody {\n  gap: var(--spacing-2);\n  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3);\n}\n\n.deleteDescription {\n  margin: var(--spacing-1) 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n}\n\n.deleteActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacing-2);\n}\n\n.deleteActions .deleteButton {\n  min-height: 32px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-width: 1px;\n  font-weight: var(--font-weight-medium);\n}\n\n.deleteActions .deleteDismiss {\n  width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelBody": `HliW6P`,
	"panelContent": `uYcL8H`,
	"panelFooter": `uB5Fzz`,
	"panelState": `tayXPq`,
	"panelStateIcon": `llN9xL`,
	"panelStateTitle": `q9MS4j`,
	"panelStateDescription": `o_4iYD`,
	"item": `Qrg61T`,
	"addressLine": `ktZyoE`,
	"alert": `qgFRh_`,
	"deleteModal": `yh9neU`,
	"deleteBody": `jtlvHa`,
	"deleteDescription": `WP94Ly`,
	"deleteActions": `bfTFBa`,
	"deleteButton": `iinXwz`,
	"deleteDismiss": `dkXH_s`
};
module.exports = ___CSS_LOADER_EXPORT___;
